import { DialogTitleProps, default as MuiDialogTitle } from '@mui/material/DialogTitle'
import * as React from 'react'

const DialogTitle: React.FC<React.PropsWithChildren<DialogTitleProps>> = ({ children, ...props }) => (
  <MuiDialogTitle {...props}>{children}</MuiDialogTitle>
)

export default DialogTitle
